"use strict";

import {gh} from '../../general/general-helpers';

(function( $ ) {

	// Only for Bookshelf page
	if ( gh.body.classList.contains('bookshelf-page') ) {

		/* Book image hover
		-------------------------------------------------------------------*/
		// if ( ! gh.isMobileDevice ) {
			$( '#hero-books-hover' ).on( 'mouseenter mouseleave', '.hero-section__bhi', function() {
				const bookNumber = this.getAttribute( 'data-book' ),
				      // find corresponding image
				      img        = this.parentElement.parentElement.querySelectorAll( '.hero-section__books-img' )[ bookNumber ];

				img.classList.toggle( 'active' );
			} );
		// } // is mobile device

	} // IF this page
})( jQuery );

